import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';
import classNames from 'classnames';
import Button from './Button';
import { ArrowLeft, ArrowRight } from '../icons';

function PrimaryButton(props) {
  return <Button {...props} />;
}

function SecondaryButton(props) {
  return <Button {...props} inverted />;
}

const ContinueButton = translate()(props => (
  <PrimaryButton
    colorScheme="green"
    label={props.t('buttons.continue')}
    IconRight={ArrowRight}
  />
));

const BackButton = translate()(props => (
  <SecondaryButton
    colorScheme="green"
    label={props.t('buttons.back')}
    IconLeft={ArrowLeft}
  />
));

const GraphButton = props => (
  <Button
    className={classNames('graph-button', {
      'graph-button--inactive': !props.active
    })}
    inverted
    {...props}
  />
);

const BorderlessButton = props => (
  <Button className="borderless-button" inverted {...props} />
);

GraphButton.defaultProps = {
  active: false
};

GraphButton.propTypes = {
  active: PropTypes.bool
};

export {
  Button,
  PrimaryButton,
  SecondaryButton,
  ContinueButton,
  BackButton,
  GraphButton,
  BorderlessButton
};



// WEBPACK FOOTER //
// ./src/components/buttons/index.js